var map = {
	"./mood-anger.png": 4179,
	"./mood-anticipation.png": 7984,
	"./mood-badge.png": 6270,
	"./mood-disgust.png": 9394,
	"./mood-fear.png": 8478,
	"./mood-joy.png": 2499,
	"./mood-love.png": 5589,
	"./mood-optimism.png": 8733,
	"./mood-percentage_0.png": 7304,
	"./mood-percentage_10.png": 9109,
	"./mood-percentage_100.png": 8908,
	"./mood-percentage_20.png": 2730,
	"./mood-percentage_30.png": 4285,
	"./mood-percentage_40.png": 7766,
	"./mood-percentage_50.png": 9790,
	"./mood-percentage_60.png": 4957,
	"./mood-percentage_70.png": 1914,
	"./mood-percentage_80.png": 4750,
	"./mood-percentage_90.png": 8933,
	"./mood-pessimism.png": 9524,
	"./mood-placeholder.png": 7035,
	"./mood-sadness.png": 7139,
	"./mood-surprise.png": 731,
	"./mood-trust.png": 9914,
	"./mood-type-overview.png": 4565,
	"./moods-preview.png": 5755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 648;